import { useState } from "react";
import { motion } from "framer-motion";
import { Box, Typography, Button } from "@mui/material";
import Login from "./Login";
import SignUp from "./SignUp";
import Header from "../Layout/Header";

const AuthWrapper = () => {
  const [isLogin, setIsLogin] = useState(true);

  const changeHandler = () => {
    setIsLogin((prev) => !prev);
  };

  return (
    <>
      <Header />
      <Box className="auth-container d-flex">
        <Box className="auth-box">
          {/* Login Form */}
          <motion.div
            className="form-section relative"
            initial={{ opacity: 1, x: 0 }}
            animate={{ opacity: isLogin ? 1 : 0, x: isLogin ? 0 : "100%" }}
            transition={{ duration: 0.6 }}
            style={{ display: isLogin ? "block" : "none" }}
          >
            <Login />
          </motion.div>

          {/* Sign Up Form */}
          <motion.div
            className="form-section relative"
            initial={{ opacity: 0, x: "100%" }}
            animate={{ opacity: isLogin ? 0 : 1, x: isLogin ? "0%" : "100%" }}
            transition={{ duration: 0.6 }}
            style={{ display: isLogin ? "none" : "block" }}
          >
            <SignUp />
          </motion.div>
        </Box>

        {/* Cover Section */}
        <motion.div
          className="form-cover"
          initial={{ x: "0%" }}
          animate={{ x: isLogin ? "0%" : "-50vw" }}
          transition={{ duration: 0.6 }}
        >
          <Box className="cover-content">
            <Box className="cover-Text">
              <Typography variant="h2">
                {isLogin ? "Hello There !!" : "Welcome Back!"}
              </Typography>
              <Typography variant="body1">
                {isLogin
                  ? `If you don’t have an account or you didn't registerd yet, click Sign Up and start your journey with us.`
                  : `Already have an account? Awesome !! Click Login to get started`}
              </Typography>

              <Box className="text-center">
                <Button class="cta" onClick={changeHandler}>
                  <Typography variant="body1" component="span">
                    {" "}
                    {isLogin ? "Sign Up" : "Login"}{" "}
                  </Typography>
                  <svg width="15px" height="10px" viewBox="0 0 13 10">
                    <path d="M1,5 L11,5"></path>
                    <polyline points="8 1 12 5 8 9"></polyline>
                  </svg>
                </Button>
              </Box>
            </Box>
          </Box>
        </motion.div>
      </Box>
    </>
  );
};

export default AuthWrapper;
